// extracted by mini-css-extract-plugin
export var modal = "_m4-0";